import { combineReducers, configureStore } from "@reduxjs/toolkit";
import resetPasswordReducer from "../reducer/resetPasswordSlice";
import notificationSlice from "../reducer/notificationSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import searchReducer from '../reducer/initSearchSlice';
import appCarouselSlice from "../reducer/appCarouselSlice";

const rootReducer = combineReducers({
  resetPassword: resetPasswordReducer,
  notification: notificationSlice,
  hotelSearch: searchReducer,
  carousel: appCarouselSlice,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export { store, persistor };
